<template>
  <span>{{ displayValue }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    duration: {
      type: Number,
      default: 1000
    },
    formatFunction: {
      type: Function,
      default: null
    },
    hideSensitiveData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayValue: 0,
      animationFrame: null,
      startTime: null,
      startValue: 0
    };
  },
  watch: {
    value: {
      handler(newValue) {
        if (this.hideSensitiveData) {
          this.displayValue = '****';
          return;
        }

        // If value is not a number, just display it directly
        if (isNaN(Number(newValue))) {
          this.displayValue = newValue;
          return;
        }

        // Cancel any ongoing animation
        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
        }

        this.startValue = Number(this.displayValue) || 0;
        const endValue = Number(newValue);

        // If the values are the same, no need to animate
        if (this.startValue === endValue) {
          return;
        }

        this.startTime = null;
        this.animate(endValue);
      },
      immediate: true
    },
    hideSensitiveData: {
      handler(newValue) {
        if (newValue) {
          this.displayValue = '****';
        } else {
          this.displayValue = this.formatValue(this.value);
        }
      },
      immediate: true
    }
  },
  methods: {
    animate(endValue) {
      const animateStep = (timestamp) => {
        if (!this.startTime) this.startTime = timestamp;
        const progress = Math.min((timestamp - this.startTime) / this.duration, 1);
        const currentValue = this.startValue + progress * (endValue - this.startValue);

        this.displayValue = this.formatValue(currentValue);

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(animateStep);
        } else {
          this.displayValue = this.formatValue(endValue);
          this.animationFrame = null;
        }
      };

      this.animationFrame = requestAnimationFrame(animateStep);
    },
        formatValue(value) {
      if (this.formatFunction) {
        return this.formatFunction(value);
      }

      // Default formatting - round to nearest integer with no decimals
      return Math.round(value).toString();
    }
  },
  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }
};
</script>
